module.exports = __webpack_public_path__ + "static/img/zhuanli-3.6d85ea33.png";